// @ts-nocheck
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { css, StyleSheet } from 'aphrodite/no-important'
import _ from 'lodash'

import { colors } from '@lmc/common/constants'
import Dot from '../Dot/Dot'
import { IconSectionHeader } from '../IconSectionHeader'
import { AntdSteps } from '../AntdSteps'
import { Glyph } from '../../../LEGACY/Glyph'
import { isBrowser, isTablet } from 'react-device-detect'

export default class StepList extends PureComponent<any, any> {
  state = {
    currentStep: 0,
    displayStep: 0,
    totalSteps: 0,
  }

  componentDidMount() {
    const { children } = this.props
    if (children && children.length) {
      this.setTotalSteps(children)
    }
  }

  componentDidUpdate(prevProps) {
    const { children } = this.props
    if (children && children.length && prevProps.children !== children) {
      this.setTotalSteps(children)
    }
  }

  setTotalSteps = (children) => {
    this.setState({ totalSteps: _.compact(children).length - 1 })
  }

  setCurrentStep = (step) => {
    this.setState({ currentStep: step })
  }

  goToPreviousStep = () => {
    this.setState((prevState) => ({
      displayStep: prevState.displayStep - 1,
    }))
    this.setPreviousStep()
  }

  goToNextStep = () => {
    this.setState((prevState) => ({
      displayStep: prevState.displayStep + 1,
    }))
    this.setNextStep()
  }

  setPreviousStep = () => {
    const { currentStep } = this.state

    if (!this.props.children[currentStep - 1]) {
      this.setCurrentStep(currentStep - 1)
      setTimeout(this.setPreviousStep)
    } else {
      this.setCurrentStep(currentStep - 1)
    }
  }

  setNextStep = () => {
    const { currentStep } = this.state

    if (!this.props.children[currentStep + 1]) {
      this.setCurrentStep(currentStep + 1)
      setTimeout(this.setNextStep)
    } else {
      this.setCurrentStep(currentStep + 1)
    }
  }

  getDots = () => {
    const { displayStep, totalSteps } = this.state
    const { modalTitle, stepLabels, useAntdSteps } = this.props

    return useAntdSteps ? (
      <div>
        {modalTitle}
        <AntdSteps
          className="lmc-add-med-antd-steps"
          currentStep={displayStep}
          stepLabels={stepLabels}
          finalStepIndex={totalSteps}
        />
      </div>
    ) : (
      _.range(0, totalSteps + 1).map((d, i) => (
        <div
          key={i}
          className={css(
            classes.dot,
            d === displayStep ? classes.activeDot : null
          )}
        />
      ))
    )
  }

  renderHeader = () => {
    const { onClose, closeLabel, displayDots, headerProps, stepsSubheader } =
      this.props

    const chosenCss = isDesktop ? classes : mobileClasses
    const dots = displayDots === false ? null : this.getDots()

    if (isDesktop)
      return (
        <div className={css(chosenCss.headerContainer)}>
          <div
            data-testid="close-modal"
            className={`lmc-hoverable-opacity ${css(chosenCss.cancelButton)}`}
            onClick={onClose}
          >
            <Dot
              label={<Glyph name="x" size="xs" style={{ margin: 1 }} />}
              selectable
              color={colors.red}
              active
              size={24}
              fontSize={12}
            />
            <span className={css(classes.cancelText)}>{closeLabel}</span>
          </div>
          <div className={css(chosenCss.dotsContainer)}>{dots}</div>
          {stepsSubheader}
          {headerProps ? (
            <div className={css(classes.sectionHeader)}>
              <IconSectionHeader {...headerProps} />
            </div>
          ) : null}
        </div>
      )

    return (
      <div>
        <div className={css(chosenCss.headerContainer)}>
          {this.renderBackGlyph()}
          {displayDots && (
            <div className={css(chosenCss.dotsContainer)}>{dots}</div>
          )}
          <div
            className={`lmc-hoverable-opacity ${css(chosenCss.cancelButton)}`}
            onClick={onClose}
          >
            <Dot
              label={<Glyph name="x" size="xs" />}
              selectable
              color={colors.red}
              active
              size={24}
              fontSize={12}
            />
          </div>
        </div>
        {headerProps ? (
          <div className={css(classes.sectionHeader)}>
            <IconSectionHeader {...headerProps} />
          </div>
        ) : null}
      </div>
    )
  }

  renderBackIcon = () => {
    const { backIconColor, backIcon, backText, displaySelection, headerProps } =
      this.props
    const { currentStep } = this.state

    if (displaySelection === false) return null

    if ((!backIcon && !backIconColor) || currentStep === 0) {
      return headerProps ? (
        <div className={css(classes.selectionContainer)} />
      ) : null
    }
    const iconColor = backIconColor || colors.background
    return (
      <div
        className={css(classes.selectionContainer)}
        style={{
          paddingTop: headerProps ? (isDesktop ? 130 : 45) : 80,
        }}
      >
        <div className={css(classes.selectionLink)}>
          <div
            className={css(classes.iconButton)}
            style={{ backgroundColor: iconColor }}
          >
            <img alt="" src={backIcon} className={css(classes.icon)} />
          </div>
          {backText}
        </div>
      </div>
    )
  }

  renderBackGlyph = () => {
    const { currentStep } = this.state
    const chosenCss = isDesktop ? classes : mobileClasses

    if (currentStep === 0)
      return (
        <div className={css(chosenCss.backGlyph)}>
          <div className={css(classes.noGlyph)} />
        </div>
      )

    return (
      <div className={css(chosenCss.backGlyph)}>
        <a
          className={css(classes.selectionLink)}
          onClick={this.goToPreviousStep}
        >
          <Glyph name="chevron-left" size="large" />
        </a>
      </div>
    )
  }

  /** 
    
    @param {node} modalTitle. Modal title component. Only used
    in conjunction with antd stepper. Is above stepper in the
    screen

    @param {node} stepsSubheader. Subheader component. Only used
    in conjunction with antd stepper. Is below stepper in the
    screen

    */
  render() {
    const { currentStep } = this.state
    const { displaySubmit, header, children, stepStyle } = this.props
    const steps = React.Children.map(children, (child, index) => {
      if (child)
        return React.cloneElement(child, {
          isActive: index === currentStep,
          displayPrevious: currentStep > 0,
          displayNext: currentStep < children.length - 1,
          displaySubmit:
            displaySubmit === false
              ? false
              : currentStep === children.length - 1,
          goToPreviousStep: this.goToPreviousStep,
          goToNextStep: this.goToNextStep,
          style: stepStyle,
        })
    })

    return (
      <div className={css(classes.container)}>
        {this.renderHeader()}
        {this.renderBackIcon()}
        {isDesktop && this.renderBackGlyph()}
        {header || null}
        {steps || null}
      </div>
    )
  }
}

const isDesktop = isBrowser || isTablet

StepList.propTypes = {
  modalTitle: PropTypes.node,
  stepsSubheader: PropTypes.node,
}

const classes = StyleSheet.create({
  backGlyph: {
    position: 'fixed',
    top: '50%',
    left: 20,
    transform: 'translate(0%, -50%)',
  },
  container: {
    width: '100vw',
    zIndex: 100,
    position: 'absolute',
    left: 0,
    top: 0,
    height: '100vh',
    overflow: 'auto',
    background: colors.background,
  },
  noGlyph: {
    background: colors.background,
    height: 64,
    width: 33,
  },
  selectionContainer: {
    textAlign: 'center',
    height: 70,
    paddingTop: 80,
  },
  selectionLink: {
    color: colors.darkgrey,
    fontSize: 15,
    paddingTop: 8,
    letterSpacing: '0.8px',
    fontWeight: 300,
  },
  categorySelection: {
    opacity: 0.8,
    textAlign: 'center',
  },
  iconButton: {
    width: 30,
    height: 30,
    borderRadius: 10,
    margin: '0 auto 5px',
  },
  icon: {
    width: 12,
    marginTop: 6,
  },
  headerContainer: {
    background: colors.background,
    paddingBottom: 20,
    paddingTop: 10,
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100vw',
    zIndex: 10,
  },
  cancelButton: {
    cursor: 'pointer',
    display: 'inline-block',
    marginLeft: 50,
    position: 'relative',
    top: 20,
  },
  dotsContainer: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
  },
  dot: {
    height: 11,
    width: 11,
    margin: '0 8px',
    backgroundColor: colors.grey,
    borderRadius: '50%',
    display: 'inline-block',
  },
  activeDot: {
    backgroundColor: colors.pink,
  },
  sectionHeader: {
    margin: 'auto',
    width: isDesktop ? '80%' : '100%',
    padding: '20px 20px 0px',
    paddingTop: isDesktop ? null : 70,
  },
})

const mobileClasses = StyleSheet.create({
  headerContainer: {
    alignItems: 'center',
    background: 'rgba(255, 255, 255, 0.9)',
    display: 'flex',
    justifyContent: 'space-between',
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100vw',
  },
})
